import Link from 'next/link';
import { cx } from '@/utils';

import { formatDate } from '@/utils/dateHelpers';
import DownloadFileImage from '@/components/common/Icons/DownloadFileImage';

type Props = {
  title: string;
  publicationDate: string;
  expeditionDate: string;
  isFullScreen?: boolean;
  description: string;
  downloadText: string | null | undefined;
  downloadLink: string | null | undefined;
};

const CardDownloadParticipateStyleA = ({
  title,
  publicationDate,
  isFullScreen = true,
  description,
  downloadText,
  downloadLink,
}: Props) => {
  return (
    <div
      className={cx(
        'flex h-[200px] animate-fade-in flex-col justify-between rounded-md border-[2px] border-transparent bg-white py-[20px] shadow-lg  hover:border-primary ',
        { 'gap-[20px] px-[30px]': isFullScreen },
        { 'gap-[10px] px-[15px]': !isFullScreen }
      )}
    >
      <div className="flex flex-col gap-[5px]">
        <label className="font-workSans text-[14px] font-normal uppercase leading-[19px] text-silver">
          {formatDate(publicationDate, 'MMMM D YYYY')}
        </label>
        <label className="truncate font-workSans text-[16px] font-semibold leading-[19px] text-tundora">
          {title}
        </label>
        <label className="line-clamp-2 font-workSans text-[16px] font-normal leading-[19px] text-tundora">
          {description}
        </label>
      </div>
      <Link
        className="group flex w-[fit-content] transform cursor-pointer items-center gap-[10px] self-center rounded-md border-[2px]  border-primary px-[10px] py-[5px] text-primary transition duration-75 ease-in-out hover:scale-105 hover:bg-primary hover:text-white"
        href={downloadLink ? downloadLink : '#'}
        download
      >
        <DownloadFileImage
          width={32}
          height={32}
          className="text-primary duration-75 ease-in-out group-hover:text-white"
        />
        <label className="line-clamp-1 cursor-pointer select-none font-workSans text-[16px] font-normal leading-[19px] text-primary transition duration-75  ease-in-out group-hover:text-white">
          {downloadText || 'Descargar'}
        </label>
      </Link>
    </div>
  );
};

export default CardDownloadParticipateStyleA;
